<template>
  <div name="imagesShow">
    <section class="leftSection">
      <div class="upIcon">
        <el-button
          class="arrowBtn"
          icon="el-icon-arrow-up"
          v-show="!minusDisable"
          @click="changePageNum('minus')"
        ></el-button>
      </div>
      <div class="imagesArea">
        <div
          class="imageItem"
          :class="{flex_33: pageSizeIs3}"
          v-for="item in currentList"
          :key="item.id"
        >
          <div class="infoBorder" :class="{active: active === item.id}" @click="checkImage(item)">
            <el-image class="img" :src="item.url.littleImg" fit="contain" />
            <div class="otherInfo" v-if="pageSizeIs3">
              <div>{{item.info.houseType}}</div>
              <div>{{item.info.howBedroom}}</div>
              <div>{{item.info.buildingArea}}㎡</div>
            </div>
          </div>
        </div>
      </div>
      <div class="downIcon">
        <el-button
          class="arrowBtn"
          icon="el-icon-arrow-down"
          v-show="!addDisable"
          @click="changePageNum('add')"
        ></el-button>
      </div>
    </section>
    <section class="rightSection">
      <div class="image" v-if="houseTypePanoramaUrl">
        <img class="img" @click="jumpUrl()" src="../../../../assets/img/quanjing361.jpg" />
      </div>
      <el-image style="width: 100%; height: calc(100% - 50px);" :src="currentImage" fit="contain" />
    </section>
    <el-dialog
      title="全景实况"
      width="90%"
      :visible.sync="dialogVisible"
      :fullscreen="true"
      center
    >
      <iframe
        id="mainIframe"
        name="mainIframe"
        :src="houseTypePanoramaUrl"
        frameborder="0"
        scrolling="auto"
      ></iframe>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">返 回</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type='text/babel'>
  export default {
    name: 'imagesShow',
    props: {
      pageSize: {
        type: Number,
        default: 4,
      },
      list: {
        type: Array,
      }
    },
    data () {
      return {
        active: '',
        pageNum: 0,
        dialogVisible: false,
        houseTypePanoramaUrl: ''
      };
    },
    watch: {
      list: {
        deep: true,
        immediate: true,
        handler(val) {
          this.active = val[0].id;
          this.houseTypePanoramaUrl = val[0].houseTypePanoramaUrl;
          console.log(val[0])
        }
      }
    },
    computed: {
      pageSizeIs3() {
        return this.pageSize === 3;
      },
      start() {
        return this.pageNum * this.pageSize;
      },
      end() {
        return this.start + this.pageSize;
      },
      currentImage() {
        return this.list.filter(item => this.active === item.id)[0].url.path;
      },
      currentList() {
        return this.list.slice(this.start, this.end);
      },
      minusDisable() {
        return this.pageNum <= 0;
      },
      addDisable() {
        return this.end >= this.list.length;
      }
    },
    methods: {
      jumpUrl() {
        this.dialogVisible = true;
      },
      checkImage(item) {
        this.active = item.id;
        this.houseTypePanoramaUrl = item.houseTypePanoramaUrl;
      },
      changePageNum(type) {
        if (type === 'add') {
          this.pageNum++;
        } else if (type === 'minus') {
          this.pageNum--;
        }
      }
    },
    created() {}
  };
</script>
<style scoped lang="less">
[name="imagesShow"] {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 20px 30px;
  display: flex;
  .leftSection {
    flex: 340px 0 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .upIcon,
    .downIcon {
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      .arrowBtn {
        width: 86px;
        height: 26px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .imagesArea {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      overflow: hidden;
      .imageItem {
        width: 120px;
        flex: 25% 0 0;
        box-sizing: border-box;
        padding: 10px 0;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        .infoBorder {
          width: 100%;
          height: 100%;
          background: #fff;
          border: 2px solid #e4e7ed;
          padding: 6px 10px;
          box-sizing: border-box;
          cursor: pointer;
          overflow: hidden;
          position: relative;
          .img {
            width: 100%;
            height: 100%;
          }
        }
        .active {
          border: 2px solid #409eff;
        }
      }
      .flex_33 {
        flex: 33.333% 0 0;
        width: 300px;
        .infoBorder {
          display: flex;
          .img {
            flex: 110px 0 0;
          }
          .otherInfo {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 5px 0;
            justify-content: space-around;
            > div {
              max-width: 165px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }
  .rightSection {
    flex: 1;
    .image {
      display: inline-block;
      line-height: 50px;
      margin-left: 20px;
      text-align: right;
      height: 50px;
      width: 100%;
      .img {
        height: 50px;
        width: 50px;
      }
    }
  }
  #mainIframe {
    width: 100%;
    height: 100%;
  }
  /deep/.el-dialog__body {
    height: calc(100% - 20px);
  }
}
</style>



// WEBPACK FOOTER //
// src/page/project-system/selection/components/imagesShow.vue